import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../../components/Button';
import { useSetup } from '../../store/setupStore';
export function SetupSuccess() {
  const navigate = useNavigate();
  const {
    deviceUid,
    labels,
    reset
  } = useSetup();
  const handleDone = () => {
    reset();
    navigate('/app/profile/devices');
  };
  const handleStartMonitoring = () => {
    reset();
    navigate('/app/monitor');
  };
  return <main className="min-h-screen w-full bg-background md:bg-secondary flex flex-col items-center justify-center p-0 md:p-6 animate-fadeInUp" data-id="element-2152" data-mp="1j3e9mc7i4tg8">
      <div className="w-full max-w-[520px] min-h-screen md:min-h-[600px] bg-background md:rounded-card md:shadow-elevated flex flex-col items-center justify-center relative overflow-hidden p-6" data-id="element-2153" data-mp="1f0hoadqkuj8l">
        {/* Celebration Animation */}
        <div className="relative flex items-center justify-center w-[160px] h-[160px] mb-8 mt-12" data-id="element-2154" data-mp="10535dyvczf42">
          {/* Ripples */}
          {[1, 2, 3].map(i => <motion.div key={i} className="absolute inset-0 rounded-full border-2 border-accent" initial={{
          scale: 0.5,
          opacity: 0
        }} animate={{
          scale: 1 + i * 0.4,
          opacity: [0, 0.5, 0]
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          delay: i * 0.4,
          ease: 'easeOut'
        }} data-id="element-2155" data-mp="pjgswxqvqhtt" />)}

          {/* Main Circle */}
          <motion.div className="relative z-10 w-[100px] h-[100px] bg-accent rounded-full flex items-center justify-center shadow-elevated" initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          bounce: 0.6,
          duration: 0.8
        }} data-id="element-2156" data-mp="ydbw408fxy6t">
            <motion.div initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: 1,
            opacity: 1
          }} transition={{
            delay: 0.4,
            duration: 0.4
          }} data-id="element-2157" data-mp="1ujneo5wzkc0a">
              <Check size={40} className="text-white" strokeWidth={3} data-id="element-2158" data-mp="1awz4km0klwhr" />
            </motion.div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.4
      }} className="flex flex-col items-center w-full" data-id="element-2159" data-mp="16u2tdgdd12nu">
          <h1 className="text-[28px] font-semibold text-text-primary text-center mb-3" data-id="element-2160" data-mp="2w7pp8xm615wr">
            {labels.titleCase} linked successfully
          </h1>
          <p className="text-[16px] text-text-secondary text-center max-w-[300px] mb-10" data-id="element-2161" data-mp="2yt6yj9jvic6j">
            You're all set. Aurora Care is now monitoring.
          </p>

          {/* Device Info Card */}
          <div className="w-full bg-white rounded-[20px] shadow-card p-5 flex items-center justify-between mb-10 border border-border" data-id="element-2162" data-mp="38l2xemtsa6bt">
            <div data-id="element-2163" data-mp="3dicyizqjc6fh">
              <p className="text-[12px] text-text-secondary uppercase tracking-wider font-semibold mb-1" data-id="element-2164" data-mp="3dkz5ax5lqhwn">
                Connected Device
              </p>
              <p className="text-[16px] font-medium text-text-primary font-mono" data-id="element-2165" data-mp="2kv8miat0yru7">
                {deviceUid || labels.productName}
              </p>
            </div>
            <div className="flex items-center space-x-2 bg-accent/10 px-3 py-1.5 rounded-full" data-id="element-2166" data-mp="2ut69kuz5eil8">
              <div className="relative flex h-2 w-2" data-id="element-2167" data-mp="53uh47epfej7">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75" data-id="element-2168" data-mp="531ftlyilh8g"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent" data-id="element-2169" data-mp="7nr5zmjtai8u"></span>
              </div>
              <span className="text-[13px] font-semibold text-accent" data-id="element-2170" data-mp="3mfd985n5gwf">
                Active
              </span>
            </div>
          </div>

          <div className="w-full space-y-4 mt-auto mb-4" data-id="element-2171" data-mp="hnhzbkwmyr7c">
            <Button onClick={handleStartMonitoring} data-id="element-2172" data-mp="cmarxmyenu17">Start Monitoring</Button>
            <div className="text-center" data-id="element-2173" data-mp="qmllixr3nmq2">
              <button onClick={handleDone} className="text-text-secondary font-medium text-[15px] hover:text-text-primary transition-colors" data-id="element-2174" data-mp="qljyrw0q1bsi">
                Done
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </main>;
}